import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { DollarSign } from "lucide-react";
import RevenueEarned from "./Revenue";
import { CancelledPlans, NewPlans, RenewPlans } from "./NewPlans";

const RevenueOverview = ({ dateFilter }) => {
  const getDateDescription = () => {
    switch (dateFilter) {
      case "today":
        return "Today's";
      case "yesterday":
        return "Yesterday's";
      case "7days":
        return "Last 7 days";
      case "30days":
        return "Last 30 days";
      case "90days":
        return "Last 90 days";
      default:
        return "";
    }
  };

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C] text-white border-none shadow-lg hover:shadow-xl transition-all p-24 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <DollarSign className="h-5 w-5 mr-8 text-[#9b87f5]" />
            Revenue Overview
          </CardTitle>
          <Button variant="link" asChild>
            <a href="/accounts" style={{ color: "#1EAEDB" }}>
              View All
            </a>
          </Button>
        </div>
        <CardDescription className="text-gray-400 text-center">
          {`${getDateDescription()} revenue metrics`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <RevenueEarned dateFilter={dateFilter} />
          <NewPlans dateFilter={dateFilter} />
          <RenewPlans dateFilter={dateFilter} />
          <CancelledPlans dateFilter={dateFilter} />
        </div>
      </CardContent>
    </Card>
  );
};

export default RevenueOverview;
